module.exports = __webpack_public_path__ + "img/ic_services_breakfast.796781f4.svg";